import { BANNERS } from "../../constants/banners";

import ribeirao from "../img/unidades/rp.png"
import sjrp from "../img/unidades/sjrp.png"
import campinas from "../img/unidades/camp.png"

// Banners da página de conversão
const bannerConversaoCampinasDesktop = BANNERS.conversao.campinas.desktop;
const bannerConversaoCampinasMobile = BANNERS.conversao.campinas.mobile;
const bannerConversaoCampinasTablet = BANNERS.conversao.campinas.tablet;

const bannerConversaoRibeiraoDesktop = BANNERS.conversao.ribeirao.desktop;
const bannerConversaoRibeiraoMobile = BANNERS.conversao.ribeirao.mobile;
const bannerConversaoRibeiraoTablet = BANNERS.conversao.ribeirao.tablet;

const bannerConversaoSjrpDesktop = BANNERS.conversao.sjrp.desktop;
const bannerConversaoSjrpMobile = BANNERS.conversao.sjrp.mobile;
const bannerConversaoSjrpTablet = BANNERS.conversao.sjrp.tablet;

export const CITIES_DATA = {
  ribeirao: {
    id: "ribeirao",
    name: "Ribeirão Preto",
    shortName: "Ribeirão Preto",
    hours: "Seg-Sex: 08:00 → 18:00",
    hoursWeek: "8h às 18h",
    hoursweekend: "9h às 13:00h",

    // endereço
    address: "Av. Pres. Vargas, 474",
    neighborhood: "Jardim Sumare",
    cidade: "Ribeirão Preto",
    state: "SP",
    cep: "14025-405",

    // localização
    lat: -21.192599,
    lng: -47.8098659,

    // serviços
    cpap: true,
    home: true,
    aud: true,

    // telefone
    phone: "+551634424470",
    whatsappPhone: "558007464625",

    // banners
    bannerDesktop: bannerConversaoRibeiraoDesktop,
    bannerTablet: bannerConversaoRibeiraoTablet,
    bannerMobile: bannerConversaoRibeiraoMobile,

    //img Unidade
    image: ribeirao,
    contactInfo: "Formulário • Contato"
  },
  sjriopreto: {
    id: "sjriopreto",
    name: "São José do Rio Preto",
    shortName: "S. J. Rio Preto",
    hours: "Seg-Sex: 08:00 → 18:00",
    hoursWeek: "8h às 18h",
    hoursweekend: "9h às 13:00h",

    address: "R. Gen. Glicério, 5280",
    neighborhood: "Vila São Pedro",
    cidade: "São José do Rio Preto",
    state: "SP",
    cep: "15091-000",

    lat: -20.8250178,
    lng: -49.3988009,

    cpap: true,
    home: true,
    aud: false,

    phone: "+551733633749",
    whatsappPhone: "558007464625",

    // banners
    bannerDesktop: bannerConversaoSjrpDesktop,
    bannerTablet: bannerConversaoSjrpTablet,
    bannerMobile: bannerConversaoSjrpMobile,

    //img Unidade
    image: sjrp,

    contactInfo: "WhatsApp • Contato"
  },
  campinas: {
    id: "campinas",
    name: "Campinas",
    shortName: "Campinas",
    hours: "Seg-Sex: 09:00 → 18:00",
    hoursWeek: "9h às 18h",
    hoursweekend: "9h às 13:00h",

    address: "R. Frei Manoel da Ressurreição, 1518",
    neighborhood: "Jardim Guanabara",
    cidade: "Campinas",
    state: "SP",
    cep: "13073-027",

    lat: -22.884108,
    lng: -47.0713571,

    cpap: true,
    home: true,
    aud: false,

    phone: "+551933256912",
    whatsappPhone: "558007464625",

    // banners
    bannerDesktop: bannerConversaoCampinasDesktop,
    bannerTablet: bannerConversaoCampinasTablet,
    bannerMobile: bannerConversaoCampinasMobile,

    //img Unidade
    image: campinas,

    contactInfo: "Agende sua Visita"
  }
};